import { useApolloClient } from '@apollo/client';
import React, { useEffect, useState, useContext, useRef } from 'react';
// import { useRouter } from 'next/router';
// import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { getLoginData } from './eirLogin403.util';
import LoginFields403 from './LoginFields403';
// import { removeLocalStorageWithPrefix, setCode } from '../../hooks/useLocalStorage';
import RootContext from '../../../util/root.context';
import styles from './styles';
import fetchInfo from '../../../util/fetchModalData';
import { setCookie, removeCookie } from '../../hooks/useCookie';
import useRecaptchaV3 from '../../hooks/useRecaptchaV3';

// const { publicRuntimeConfig } = getConfig();

const LoginModal403 = ({
  enable,
  setEnableModal,
  // prequal,
  // onload,
  // setShowSubscriptionModal,
  saveLoginInfo,
  // mobile,
  // showLoader,
  loaderText,
  // setShowLoader,
  onLoadingDisablecta,
  // setOnLoadingDisablecta,
  // isR6Customer,
  // isPrepayCustomer,
  // enableCloseCTA,
  // registrationIncompleteModal,
  // cmsCollectionData,
}) => {
  const { executeRecaptcha } = useRecaptchaV3('eirLogin');
  const recaptchaRef = useRef(null);
  const graphql = useApolloClient();
  const theme = useTheme();
  // const router = useRouter();
  const [emailAddress, setemailAddress] = useState('');
  const [userPassword, setUserPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  // const [isApiError, setIsApiError] = useState(false);
  const [disablecta, setDisablecta] = useState(true);
  const [loginTitle, setLoginTitle] = useState('');
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const { dispatch } = useContext(RootContext);
  const [load, setLoad] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [invalidText, setInvalidText] = useState('');
  const [captchaV2, setCaptchaV2] = useState('');
  const [captchaV2Error, setCaptchaV2Error] = useState(false);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'eir-login-403',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    if (enable) {
      setemailAddress('');
      setUserPassword('');
    }
  }, [enable]);

  function handleOnChange(value) {
    if (value == null) {
      setCaptchaV2(null);
      setLoginError('recaptcha error');
      setDisablecta(true);
      // setOnLoadingDisablecta(true);
      setShowLoader(false);
      setCaptchaV2Error(!captchaV2Error);
    } else {
      setCaptchaV2Error(!captchaV2Error);
      setCaptchaV2(value);
      setLoginError('');
      setDisablecta(false);
    }
  }

  const handleLoginButton = async () => {
    setShowLoader(true);
    saveLoginInfo({ type: 'LOGIN', payload: { email: emailAddress } });
    setCookie('ION', 'EMAIL_ADDRESS', emailAddress);
    dispatch({ type: 'ENABLE_LOGOUT', payload: true });
    removeCookie('found-403');
    const recaptchaV3Token = await executeRecaptcha();
    await getLoginData({
      graphql,
      emailAddress,
      userPassword,
      recaptchaV3Token,
      setInvalidText,
      captchaV2,
      captchaV2Error,
      setCaptchaV2Error,
      setDisablecta,
      recaptchaRef,
    });
    setEnableModal(false);
    setShowLoader(false);
  };

  const handleLoginButtonThroughPass = () => {
    handleLoginButton();
  };
  const closeHandler = () => {
    setEnableModal(false);
  };

  useEffect(() => {
    if (Object.keys(cmsCollectionData || {}).length !== 0) {
      setLoginTitle(cmsCollectionData?.attributes?.title);
    }
  }, [cmsCollectionData]);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={enable}
      // enableCloseCTA={enableCloseCTA}
      closeHandler={closeHandler}
      onLoadingDisablecta={onLoadingDisablecta}
      // desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
      //   cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
      // }`}
      // mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
      //   cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
      // }`}
      // desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
      //   cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url || ''
      // }`}
      // mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
      //   cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url || ''
      // }`}
      sx={styles(theme).MobileClass}
      title={loginTitle}
      description={
        <LoginFields403
          emailAddress={emailAddress}
          setemailAddress={setemailAddress}
          userPassword={userPassword}
          setUserPassword={setUserPassword}
          loginError={loginError}
          // isApiError={isApiError}
          // setIsApiError={setIsApiError}
          setDisablecta={setDisablecta}
          setLoginError={setLoginError}
          recaptchaRef={recaptchaRef}
          onLoadingDisablecta={onLoadingDisablecta}
          handleLoginButtonThroughPass={handleLoginButtonThroughPass}
          invalidText={invalidText}
          /* eslint-disable react/jsx-no-bind */
          handleOnChange={handleOnChange}
        />
      }
      cta={[
        {
          // text: 'Login',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Login',
          type: 'solid',
          showLoader,
          loaderText,
          disable: disablecta,
          action: () => handleLoginButton(),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
      ]}
      // showLoader={showLoader}
      // disableCloseOnBackdropClick
      // disableCloseOnEscapeKeyDown
      load={load}
    />
  );
};

export default LoginModal403;
